import React, { useState, useEffect, useContext, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import AppContext from '../../../../context/AppContext';
import "../../../../assets/css/screens/serviceprovider/dashboard/helpandsupport/WorkerChat.css";
import WorkerNavbar from '../../../../components/serviceprovider/workerdashboard/Workernavbar/WorkerNavbar';
import echo from '../../../../config/echo';
// ── Import Broken-down Components ──
import ChatHeader from '../../../../components/serviceprovider/workerdashboard/workerchat/ChatHeader';
import ChatMessagesList from '../../../../subscreens/serviceprovider/dashboard/workerdashboard/workerchat/ChatMessagesList';
import ChatInput from '../../../../components/serviceprovider/workerdashboard/workerchat/ChatInput';
import MediaPreviewModal from '../../../../components/serviceprovider/workerdashboard/workerchat/MediaPreviewModal';
import MessageSafetyModal from '../../../../components/general/messagesafetymodal/MessageSafteyModal';

const WorkerChat = () => {
  const { baseUrl, authToken,baseUrlForFile } = useContext(AppContext);
  const { conversationId }     = useParams();
  console.log("========== WORKER CHAT PARAM ==========");
console.log("URL:", window.location.pathname);
console.log("conversationId:", conversationId);
  const location               = useLocation();
  const navigate               = useNavigate();
  const [showSafetyModal, setShowSafetyModal] = useState(false);
  const [switchingChat, setSwitchingChat] = useState(false);

  const ticketDescription = location.state?.description;

  const [messages, setMessages] = useState([]);
  const [type,     setType]     = useState('');
  const [sending, setSending] = useState(false);

  const [customerMedia, setCustomerMedia] = useState([]);
const [workerProofs, setWorkerProofs] = useState([]);
const [isResolved, setIsResolved] = useState();
const [isJobChatClosed, setIsJobChatClosed] = useState(false);
const [jobStatus, setJobStatus] = useState(null);
const [previewImage, setPreviewImage] = useState(null);
const [previewVideo, setPreviewVideo] = useState(null);

const [isDisputed, setIsDisputed] = useState(false);
const [conversationType, setConversationType] = useState(null);
const [orderConversationId, setOrderConversationId] = useState(null);
const [disputeConversationId, setDisputeConversationId] = useState(null);
const [orderChatDisabled, setOrderChatDisabled] = useState(false);
const [disputeDescription, setDisputeDescription] = useState(
  location.state?.description || ""
);

  const bottomRef = useRef(null);

const sendMessage = async () => {
  if (sending) return; // Agar already send ho raha hai to dobara mat bhejo

  if (isResolved) {
    alert("This ticket has been resolved.");
    return;
  }

  if (orderChatDisabled) {
    alert(
      "Order chat is disabled during dispute. Please use Dispute Chat."
    );
    return;
  }

  // =========================
  // JOB CHAT TEMPORARILY CLOSED
  // =========================
  if (isJobChatClosed) {
    return;
  }

  if (!type.trim() || !conversationId) return;

  setSending(true);

  const formData = new FormData();
  formData.append("whconversation_id", Number(conversationId));
  formData.append("message", type.trim());
  formData.append("sender", "worker");
  formData.append("type", "text");

  try {
  const response = await axios.post(
    `${baseUrl}/worker/createchat`,
    formData,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        "Content-Type": "multipart/form-data",
      },
    }
  );

  console.log("WORKER SEND RESPONSE:", response.data);

  // ✅ Worker ka apna message foran UI mein show
  if (response.data?.chat) {
    setMessages(prev => {
      if (prev.some(msg => msg.id === response.data.chat.id)) {
        return prev;
      }

      return [...prev, response.data.chat];
    });
  }

  setType("");

} catch (err) {
  console.log("ERROR:", err.response?.data || err.message);

  if (
    err.response?.status === 422 &&
    err.response?.data?.suspicious
  ) {
    setShowSafetyModal(true);
    return;
  }

} finally {
  setSending(false);
}
};
 const handleKey = (e) => {
  if (e.key === "Enter" && !sending) {
    sendMessage();
  }
};

  
  // =========================
  // VIEW CHATS
  // =========================
// =========================
// VIEW CHATS
// =========================
const fetchChats = () => {
  const auth = authToken || localStorage.getItem("authToken");

  console.log("========== FETCH CHATS START ==========");
  console.log("conversationId:", conversationId);
  console.log("URL:", `${baseUrl}/worker/receviechat`);

  axios.get(`${baseUrl}/worker/receviechat`, {
    headers: {
      Authorization: `Bearer ${auth}`,
    },
    params: {
      whconversation_id: conversationId,
    },
  })
  .then(res => {

    console.log("========== WORKER CHAT RESPONSE ==========");
    console.log("STATUS:", res.status);
    console.log("DATA:", res.data);

    console.log("conversation_type:", res.data.conversation_type);
    console.log("isDisputed:", res.data.isDisputed);
    console.log("orderChatDisabled:", res.data.orderChatDisabled);
    console.log("orderConversationId:", res.data.orderConversationId);
    console.log("disputeConversationId:", res.data.disputeConversationId);
    console.log("description:", res.data.description);

    const chats = res.data.messages || [];

    setMessages(chats);
    setCustomerMedia(res.data.customerMedia || []);
    setWorkerProofs(res.data.workerProofs || []);

    // =========================
    // CHAT STATUS
    // =========================

    setIsDisputed(res.data.isDisputed === true);
    setConversationType(res.data.conversation_type || null);
    setOrderChatDisabled(res.data.orderChatDisabled === true);

    // =========================
    // ORDER CHAT STATUS
    // =========================
    if (res.data.conversation_type === "order") {

      const currentJobStatus = res.data.status;

      console.log("CURRENT JOB STATUS:", currentJobStatus);

      setJobStatus(currentJobStatus);

      // =========================
      // COMPLETED
      // =========================
      if (currentJobStatus === "completed") {

        setIsResolved(true);
        setIsJobChatClosed(false);

      }

      // =========================
      // IN PROGRESS / AWAITING CONFIRMATION
      // =========================
      else if (
        currentJobStatus === "in_progress" ||
        currentJobStatus === "awaiting_confirmation"
      ) {

        setIsResolved(false);
        setIsJobChatClosed(true);

      }

      // =========================
      // OTHER ORDER STATUS
      // =========================
      else {

        setIsResolved(false);
        setIsJobChatClosed(false);

      }

    }

    // =========================
    // DISPUTE CHAT
    // =========================
    else {

      setJobStatus(null);

      // Worker receiveChat mein dispute ke liye
      // res.data.status = helpSupport status hota hai

      setIsResolved(res.data.status === "resolved");

      // Dispute chat normally available rahegi
      // jab tak dispute resolve nahi hota
      setIsJobChatClosed(false);

    }

    // =========================
    // CONVERSATION IDS
    // =========================

    setOrderConversationId(
      res.data.orderConversationId || null
    );

    setDisputeConversationId(
      res.data.disputeConversationId || null
    );

    // =========================
    // DISPUTE DESCRIPTION
    // =========================

    if (res.data.description) {
      setDisputeDescription(res.data.description);
    }

  })
  .catch(err => {
    console.log("========== FETCH CHATS ERROR ==========");
    console.log("STATUS:", err.response?.status);
    console.log("DATA:", err.response?.data);
    console.log("ERROR:", err.message);
  });
};

  // Scroll to bottom on new message
useEffect(() => {
  console.log("========== FETCH EFFECT RUN ==========");
  console.log("Conversation ID:", conversationId);
  setSwitchingChat(false);

  if (!conversationId) {
    console.log("NO CONVERSATION ID");
    return;
  }

  console.log("CALLING fetchChats NOW");
  fetchChats();
}, [conversationId]);
useEffect(() => {

  console.log("WORKER CHAT MOUNTED");

  if (!conversationId) return;

  console.log("Joining Conversation:", `conversation-${conversationId}`);

  const channel = echo.channel(`conversation-${conversationId}`);
channel.listen(".ChatMessageSent", (event) => {

  // ✅ Admin ne ticket resolve kar di
  if (event.status === "resolved") {
    setIsResolved(true);
  }

  // ✅ Agar message hi nahi hai to yahin stop
  if (!event.chat) return;

  setMessages(prev => {
    const exists = prev.find(msg => msg.id === event.chat.id);

    if (exists) {
      return prev;
    }

    return [...prev, event.chat];
  });

});

  return () => {
    console.log("LEAVING CHANNEL");
    echo.leave(`conversation-${conversationId}`);
  };

}, [conversationId]);
 return (
  <>
    <div className="wc-navbar-wrapper">
      {/* <WorkerNavbar /> */}
    </div>

    <div className="wc-root">

 <div className="wc-chat-header">

  <div className="wc-chat-title">
    <button
      className="wc-back-btn"
      onClick={() => navigate(-1)}
      title="Go Back"
    >
      ←
    </button>

    <h2>
      {conversationType === "dispute"
        ? "Dispute Chat"
        : "Order Chat"}
    </h2>
  </div>

  <div className="wc-chat-switch">

    {isDisputed &&
      conversationType === "dispute" &&
      orderConversationId && (
        <button
          className="cc-switch-chat-btn"
          disabled={switchingChat}
          onClick={() => {
            setSwitchingChat(true);
            navigate(`/worker-chat/${orderConversationId}`);
          }}
        >
          {switchingChat ? (
            <>
              <span className="wc-switch-spinner"></span>
              Switching...
            </>
          ) : (
            "Switch to Order Chat"
          )}
        </button>
      )}

    {isDisputed &&
      conversationType === "order" &&
      disputeConversationId && (
        <button
          className="cc-switch-chat-btn"
          disabled={switchingChat}
          onClick={() => {
            setSwitchingChat(true);
            navigate(`/worker-chat/${disputeConversationId}`);
          }}
        >
          {switchingChat ? (
            <>
              <span className="wc-switch-spinner"></span>
              Switching...
            </>
          ) : (
            "Switch to Dispute Chat"
          )}
        </button>
      )}

  </div>
</div>
     <ChatMessagesList
  ticketDescription={conversationType === "dispute" ? disputeDescription : null}
  customerMedia={conversationType === "dispute" ? customerMedia : []}
  workerProofs={conversationType === "dispute" ? workerProofs : []}
  baseUrlForFile={baseUrlForFile}
  setPreviewImage={setPreviewImage}
  setPreviewVideo={setPreviewVideo}
  messages={messages}
  bottomRef={bottomRef}
/>

    
{orderChatDisabled ? (

  <div className="wc-ticket-resolved">
    <span className="wc-ticket-resolved__badge">
      ⚠️ Order chat is disabled during dispute. Please use Dispute Chat.
    </span>
  </div>

) : isResolved ? (

  <div className="wc-ticket-resolved">
    <span className="wc-ticket-resolved__badge">
      {conversationType === "dispute"
        ? "✅ This dispute has been resolved. Chat is closed."
        : "✅ This job has been completed. Chat is closed."}
    </span>
  </div>

) : isJobChatClosed ? (

  <div className="wc-ticket-resolved">
    <span className="wc-ticket-resolved__badge">
      {jobStatus === "awaiting_confirmation"
        ? "⏳ Job is awaiting confirmation. Chat is temporarily closed."
        : "⏳ Job is in progress. Chat is temporarily closed."}
    </span>
  </div>

) : (

  <ChatInput
    type={type}
    setType={setType}
    handleKey={handleKey}
    sendMessage={sendMessage}
    sending={sending}
  />

)}
      <MediaPreviewModal
        previewImage={previewImage}
        setPreviewImage={setPreviewImage}
        previewVideo={previewVideo}
        setPreviewVideo={setPreviewVideo}
      />
      <MessageSafetyModal
  show={showSafetyModal}
  onClose={() => setShowSafetyModal(false)}
/>

    </div>
  </>
);
}
export default WorkerChat;